import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';

// mui icons
import Assignment from '@mui/icons-material/Assignment';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';
import CardIcon from '../md/components/Card/CardIcon.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';

import extendedTablesStyle from '../assets/jss/crm/views/extendedTablesStyle.jsx';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch } from '../utils/utils';

const spreadsheetUploaderStyles = (theme) => ({
  root: {
    border: '1px solid black',
    width: '800px',
    backgroundColor: 'white',
    padding: '6px',
  },
  titleP: {
    fontWeight: 600,
    color: 'green',
  },
});

const FirmDropdown = ({ classes, holder, customerFirmIdNamePairs }) => {
  return (
    <select
      value={holder.state.customerFirmId}
      onChange={(event) => holder.handleCustomerFirmIdChange(event.target.value)}
    >
      <option key={0} value={0}>
        Choose Target Firm ...
      </option>
      {customerFirmIdNamePairs.map((pair) => (
        <option key={pair.firmId} value={pair.firmId}>
          {pair.firmName}
        </option>
      ))}
    </select>
  );
};

class SpreadsheetUploader extends React.Component {
  state = {
    running: false,
    displayingResults: false,
    file: undefined,
    result: undefined,
    customerFirmId: 0,
  };

  useDropdown = true;

  handleCustomerFirmIdChange(newId) {
    this.setState({ customerFirmId: newId, displayingResults: false });
  }

  handleFileChange(event) {
    const files = event.target.files;
    const file = files[0];
    this.setState({ file: file });
  }

  doUpload() {
    const uri = `/api/firm/${this.state.customerFirmId}/uploadSpreadsheetFile`;
    this.setState({ running: true, result: undefined, displayingResults: false });
    fetch(uri, { method: 'POST', body: this.state.file })
      .then((response) => response.json())
      .then((result) => {
        this.setState({ running: false, result, displayingResults: true });
        console.log('success: ' + result.success);
      })
      .catch((error) => console.log(error));
  }

  render() {
    const { classes, customerFirmIdNamePairs } = this.props;
    const showUploadButton = this.state.file && !this.state.running && !this.state.displayingResults;
    return (
      <div className={classes.root}>
        <div className={classes.titleP}>Upload Spreadsheet</div>
        <div>
          <FirmDropdown classes={classes} holder={this} customerFirmIdNamePairs={customerFirmIdNamePairs} />
        </div>
        <div>
          <input type="file" accept=".ods" name="fileToUpload" onChange={(event) => this.handleFileChange(event)} />
          {showUploadButton && <input type="button" value="Upload .ods File" onClick={() => this.doUpload()} />}
        </div>
        {this.state.displayingResults && (
          <div>
            <div className={classes.titleP}>Results</div>
            {this.state.result.success ? <span>Success!!</span> : <span>Error: {this.state.result.errorMessage}</span>}
            <table>
              <tbody>
                <tr>
                  <td>nPhones:</td>
                  <td>{this.state.result.nPhonesAddedToDb}</td>
                  <td />
                  <td>nFacilities:</td>
                  <td>{this.state.result.nFacilitiesAddedToDb}</td>
                </tr>
                <tr>
                  <td>nAddresses:</td>
                  <td>{this.state.result.nAddressesAddedToDb}</td>
                  <td />
                  <td>nFirms:</td>
                  <td>{this.state.result.nFirmsAddedToDb}</td>
                </tr>
                <tr>
                  <td>nWebLinks:</td>
                  <td>{this.state.result.nWebLinksAddedToDb}</td>
                  <td />
                  <td>nTreatmentPrograms:</td>
                  <td>{this.state.result.nTreatmentProgramsAddedToDb}</td>
                  <td />
                  <td>nPractitioners:</td>
                  <td>{this.state.result.nPractitionersAddedToDb}</td>
                </tr>
                <tr>
                  <td>nContacts:</td>
                  <td>{this.state.result.nContactsAddedToDb}</td>
                  <td>nPractitioners:</td>
                  <td>{this.state.result.nPractitionersAddedToDb}</td>
                </tr>
                <tr>
                  <td>nEdConsultants:</td>
                  <td>{this.state.result.nEdConsultantsAddedToDb}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

const SpreadsheetUploaderStyled = withStyles(spreadsheetUploaderStyles)(SpreadsheetUploader);

class SpreadsheetUploadPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: undefined,
      unauthorized: false,
      providerIdsAndNames: [],
    };
  }

  componentDidMount() {
    const role = this.props.userInfo.role;
    const onLocalMachine = window.location.hostname === 'localhost';
    if (onLocalMachine || role === 'SuperAdmin' || role === 'AllevaRep') {
      this.fetchTableData();
    } else {
      this.setState({ unauthorized: true });
    }
  }

  fetchTableData() {
    this.setState({ querying: true });
    const uri = '/api/firm/providerIdsAndNames';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ querying: false, providerIdsAndNames: json });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  customerFirmIdNamePairs() {
    return this.providerIdsAndNames.map((pair) => {
      return { id: pair.firmId, name: pair.firmName };
    });
  }

  redirecctToSaPwdChangePage() {
    this.setState({ redirect: 'saProfile' });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    if (this.state.unauthorized) {
      return (
        <div>
          <h2>Sorry! You're not allowed to be here.</h2>;
          <h3>You need to be logged in as an AllevaRep or SuperAdmin.</h3>;
        </div>
      );
    }

    const { classes, userInfo } = this.props;
    const isKim = userInfo.email.startsWith('mccall.kim');

    return (
      <Card>
        <CardHeader color="allevaOrange" icon>
          <CardIcon color="allevaOrange">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Upload Spreadsheet</h4>
        </CardHeader>
        <CardBody>
          <div style={{ marginTop: '24px', marginBottom: '24px' }}>
            <SpreadsheetUploaderStyled customerFirmIdNamePairs={this.state.providerIdsAndNames} />
          </div>
          {isKim && (
            <div>
              <span
                onClick={() => this.redirecctToSaPwdChangePage()}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                Change an SA Password
              </span>
            </div>
          )}
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const actionProducers = {
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(extendedTablesStyle)(SpreadsheetUploadPage));
